import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import { EMPTY_OBJECT } from './AddTaskList'

function UploadNewDatabase(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [sqLDbList, setSqLDbList] = useState([])
    const [databaseId, setDatabaseId] = useState(-1)
    const [databaseName, setDatabaseName] = useState('')
    const [jobFiles, setJobFiles] = useState([])
    const [selectedJobFileId, setSelectedJobFileId] = useState('')
    const [selectedJobFile, setSelectedJobFile] = useState('')
    const [filesWithinZip, setFilesWithinZip] = useState([])
    const [selectedFileWithinZip, setSelectedFileWithinZip] = useState('')

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDatabaseName(props.taskData.databaseName)
            setIsLoadingRequest(false)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setIsLoadingRequest(false)
        }

        if (props.jobFiles && props.jobFiles.length > 0) {
            setJobFiles(props.jobFiles)
            setSelectedJobFile(props.taskData.selectedZipFile)
            setSelectedJobFileId(props.taskData.selectedZipFileId)
            zipFileSelectedWithFiles(props.taskData.selectedZipFile, props.jobFiles)
            setSelectedFileWithinZip(props.taskData.selectedFileWithinZip)
            fileWithinZipSelectedWithFiles(props.taskData.selectedFileWithinZip, props.taskData.selectedZipFile)
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDatabaseName(props.taskData.databaseName)
            setIsLoadingRequest(false)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setIsLoadingRequest(false)
        }
    }, [props.taskData.databaseId, props.taskData.databaseName])

    useEffect(() => {
        if (props.jobFiles && props.jobFiles.length > 0 && props.jobFiles.length !== jobFiles.length) {
            setJobFiles(props.jobFiles)
            setSelectedJobFile(props.taskData.selectedZipFile)
            setSelectedJobFileId(props.taskData.selectedZipFileId)
            zipFileSelectedWithFiles(props.taskData.selectedZipFile, props.jobFiles)
            setSelectedFileWithinZip(props.taskData.selectedFileWithinZip)
            fileWithinZipSelectedWithFiles(props.taskData.selectedFileWithinZip, props.taskData.selectedZipFile)
        }
    }, [props.jobFiles])

    function handleDatabaseChange(event) {
        event.preventDefault()
        setIsLoadingRequest(false)
        setDatabaseId(event.target.value)

        let lookupDatabaseName = ""
        sqLDbList.forEach(db => {
            if (db.id === event.target.value) {
                lookupDatabaseName = db.dBname
                setDatabaseName(db.dBname)
            }
        })
        fireOnSaveEvent(event.target.value, lookupDatabaseName, selectedJobFileId, selectedJobFile, selectedFileWithinZip)
    }
    
    function handleZipFileChange(event) {
        event.preventDefault()
        zipFileSelected(event.target.value)
    }

    function handleFileWithinZipChange(event) {
        event.preventDefault()
        setIsLoadingRequest(false)
        fileWithinZipSelected(event.target.value)
        fireOnSaveEvent(databaseId, databaseName, selectedJobFileId, selectedJobFile, event.target.value)
    }

    function zipFileSelected(zipFileName) {
        setIsLoadingRequest(false)
        setSelectedJobFileId(zipFileName)
        setSelectedJobFile('')
        setSelectedFileWithinZip('')

        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["identifier"] === zipFileName) {
                lookup = jobFiles[x]
            }
        }

        if (lookup) {
            setSelectedJobFile(lookup["name"])
            setFilesWithinZip(lookup["zipIndividualFiles"])
            fireOnSaveEvent(databaseId, databaseName, zipFileName, lookup["name"], "")
        } else {
            setSelectedJobFileId('')
            setSelectedJobFile('')
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }
    }

    function zipFileSelectedWithFiles(zipFileName, files) {
        setIsLoadingRequest(false)
        setSelectedJobFile(zipFileName)
        setSelectedFileWithinZip('')

        let lookup = null
        for (let x = 0; x < files.length; x++) {
            if (files[x]["name"] === zipFileName) {
                lookup = files[x]
            }
        }

        if (lookup) {
            setFilesWithinZip(lookup["zipIndividualFiles"])
        } else {
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }
    }

    async function fileWithinZipSelected(fileWithinZipName) {
        setIsLoadingRequest(false)
        setSelectedFileWithinZip(fileWithinZipName)
        fireOnSaveEvent(databaseId, databaseName, selectedJobFileId, selectedJobFile, fileWithinZipName)
    }

    function fileWithinZipSelectedWithFiles(fileWithinZipName, selectedFile) {
        setIsLoadingRequest(false)
        setSelectedFileWithinZip(fileWithinZipName)
    }

    /**
     * fireOnSaveEvent
     * * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} zipFileId - Selected zip file unique ID
     * @param {string} zipFileName - Selected job zip file
     * @param {string} fileWithinZip - Desktop database found within zip file
     */
    function fireOnSaveEvent(dbId, dbName, zipFileId, zipFileName, fileWithinZip) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["selectedZipFileId"] = zipFileId
            copied["selectedZipFile"] = zipFileName
            copied["selectedFileWithinZip"] = fileWithinZip
            props.onSave(copied)
        }
    }

    return <Paper elevation={3} className="dbFunctionsPaper">
        <h3>Load New Database From File</h3>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-databse-label">Select Database</InputLabel>
            <Select
                labelId="select-databse-label"
                id="select-databse"
                label="Select Database"
                onChange={handleDatabaseChange}
                defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                value={databaseId}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={-1}>Select Database</MenuItem>
                    { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-zip-file-label">Select Zip File</InputLabel>
            <Select
                labelId="select-zip-file-label"
                id="select-zip-file"
                label="Select Zip File To Use"
                onChange={handleZipFileChange}
                value={selectedJobFileId}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Zip File</MenuItem>
                    { jobFiles.map((x) => x && x.name.toLowerCase().includes(".zip") && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-file-within-zip-label">Select File Within Zip</InputLabel>
            <Select
                labelId="select-file-within-zip-label"
                id="select-file-within-zip"
                label="Select File Within Zip"
                onChange={handleFileWithinZipChange}
                value={selectedFileWithinZip}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select File Within Zip File</MenuItem>
                    { filesWithinZip.map((x) => x && <MenuItem key={x} value={x}>[{selectedJobFile}]{x}</MenuItem>) }
                    { jobFiles.map((x) => x && !x.name.toLowerCase().includes(".zip") && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>) }
            </Select>
        </FormControl>
    </Paper>
}

export default UploadNewDatabase